var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isloading)?_c('div',{staticClass:"sp-bg",style:({height:_vm.$store.getters.bgHeight})},[_c('pacman-loader',{staticClass:"pacman",attrs:{"loading":_vm.isloading,"color":_vm.color,"size":_vm.size}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }